<template>
  <article
    :class="computedClass"
    v-bind="$attrs"
  >
    <div
      v-if="title"
      class="jade-box__header"
    >
      <jade-icon
        v-if="icon"
        :use="icon"
        size="medium"
      />
      <jade-text variant="heading-xsmall">{{ title }}</jade-text>
      <div
        v-if="this.$slots.action"
        class="jade-box__action"
      >
        <slot name="action"></slot>
      </div>
    </div>

    <div
      v-if="this.$slots.default"
      class="jade-box__main"
    >
      <slot />
    </div>
  </article>
</template>

<script>
import JadeText from '../JadeText'
import JadeIcon from '../JadeIcon'

export default {
  name: 'JadeBox',
  components: {
    JadeText,
    JadeIcon
  },
  props: {
    title: String,
    icon: String,
    hasPadding: Boolean
  },

  computed: {
    computedClass () {
      return {
        'jade-box': true,
        'has-padding': this.hasPadding
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/box.css';
</style>
